// import axios from "axios";
// import React, { useContext, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useCart } from "react-use-cart";

// const OrdersContext = React.createContext();

// export const OrderProvider = ({ children }) => {
//   const [orders, setOrders] = useState([]);
//   const { emptyCart } = useCart();
//   const [formData] = useState({
//     address: "",
//     city: "",
//     postalCode: "",
//     country: "",
//     payment: "Credit Card",
//     userId: null,
//   });

//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem("user"));
//   const config = {
//   headers: {
//     Authorization: `Bearer ${user?.token}`,
//     "Content-Type": "application/json",
//   },
// };

//   const getOrderByUserId = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders`, config);
//       console.log(response.data);
//       setOrders(response.data.data || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const createOrder = async (form) => {
//   try {
//     const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/orders`, form, config);
//     const data = response.data.data;
//     console.log("Order created:", data);

//     toast.success(`Redirecting to payment...`, {
//       position: "top-center",
//       autoClose: 2000,
//     });

//     await generatePayment(data.id);
//   } catch (err) {
//     console.log(err);
//     toast.error("Something went wrong during checkout");
//   }
// };

//   const generatePayment = async (id) => {
//   try {
//     const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/orders/${id}/pay`, {}, config);
//     const data = response.data.data;
//     window.location.href = data;
//   } catch (err) {
//     console.log(err);
//     toast.error("Failed to generate payment link");
//   }
// };

//   return (
//     <OrdersContext.Provider value={{ getOrderByUserId, orders, createOrder }}>
//       {children}
//     </OrdersContext.Provider>
//   );
// };

// export const useOrderContext = () => {
//   return useContext(OrdersContext);
// };

import axios from "axios";
import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { useCart } from "react-use-cart";
import "react-toastify/dist/ReactToastify.css";

const OrdersContext = React.createContext();

export const OrderProvider = ({ children }) => {
  const [orders, setOrders] = useState([]);
  const { emptyCart } = useCart();

  const getAuthConfig = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return {
      headers: {
        Authorization: `Bearer ${user?.token}`,
        "Content-Type": "application/json",
      },
    };
  };

  const getOrderByUserId = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/orders`,
        getAuthConfig()
      );
      setOrders(response.data.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch orders:", err);
    }
  };

  const createOrder = async (form) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/orders`,
        form,
        getAuthConfig()
      );
      const data = response.data.data;

      toast.success("Redirecting to payment...", {
        position: "top-center",
        autoClose: 2000,
      });

      window.location.href = data.redirect_url;
    } catch (err) {
      console.error("❌ Order creation error:", err);
      toast.error("Something went wrong during checkout");
    }
  };

  return (
    <OrdersContext.Provider value={{ getOrderByUserId, orders, createOrder }}>
      {children}
    </OrdersContext.Provider>
  );
};

export const useOrderContext = () => useContext(OrdersContext);